import { render, staticRenderFns } from "./Detail_FollowUp.vue?vue&type=template&id=1c5ca438&scoped=true&"
import script from "./Detail_FollowUp.vue?vue&type=script&lang=js&"
export * from "./Detail_FollowUp.vue?vue&type=script&lang=js&"
import style0 from "./Detail_FollowUp.vue?vue&type=style&index=0&id=1c5ca438&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5ca438",
  null
  
)

export default component.exports